import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61524301"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tooltip"
}
const _hoisted_2 = { class: "tooltiptext infoText" }
const _hoisted_3 = {
  key: 1,
  class: "tooltip-warning"
}
const _hoisted_4 = { class: "tooltiptext warningText" }


export default /*#__PURE__*/_defineComponent({
  __name: 'ToolTip',
  props: {
    information: { type: Boolean },
    warning: { type: Boolean },
    tip: {}
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;
const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.information)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createTextVNode(" ? "),
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.tip), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.warning)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createTextVNode(" ! "),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.tip), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})